export default function (containerMode) {
  const isProductionNodeEnv = process.env.NODE_ENV === 'production'
  const isContainerModeLive = containerMode === 'live'
  return isProductionNodeEnv && isContainerModeLive
}
